(() => {
  'use strict';
  const menus=[...document.querySelectorAll('[data-eo-header] details')];
  menus.forEach(menu=>menu.addEventListener('toggle',()=>{if(menu.open)menus.forEach(other=>{if(other!==menu)other.open=false;});}));
  document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;menus.forEach(menu=>{if(menu.open){menu.open=false;menu.querySelector('summary').focus();}});});
  document.addEventListener('click',event=>{menus.forEach(menu=>{if(!menu.contains(event.target))menu.open=false;else if(event.target.closest('a'))menu.open=false;});});
  const experience=document.querySelector('iframe[id^="OLOExperience-"]');
  if(experience){
    const origin=new URL(experience.src).origin,hash='#olo-marker-experience';
    let serial=0,pending=null;
    const links=[...document.querySelectorAll('[data-eo-header] a')];
    const markerLink=link=>{const url=new URL(link.href,location.href);return url.origin===location.origin&&url.pathname===location.pathname&&url.hash===hash;};
    const selected=()=>{
      for(const link of links){
        const url=new URL(link.href,location.href);
        if(markerLink(link)){if(location.hash===hash)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');}
        else if(url.pathname===location.pathname&&!url.hash){if(location.hash===hash)link.removeAttribute('aria-current');else link.setAttribute('aria-current','page');}
      }
    };
    const send=()=>{if(pending)experience.contentWindow.postMessage({type:'olo:marker-target-request',requestId:pending.id},origin);};
    const begin=()=>{selected();if(location.hash!==hash){pending=null;return;}pending={id:String(++serial),settleUntil:0};send();};
    const cancel=()=>{pending=null;};
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[href]');
      if(!link||!markerLink(link)||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();
      if(location.hash!==hash)history.pushState(null,'',location.pathname+location.search+hash);
      begin();
    });
    window.addEventListener('hashchange',begin);
    window.addEventListener('popstate',begin);
    window.addEventListener('wheel',cancel,{passive:true});
    window.addEventListener('touchstart',cancel,{passive:true});
    window.addEventListener('keydown',event=>{if(['ArrowDown','ArrowUp','PageDown','PageUp','Home','End','Escape',' '].includes(event.key))cancel();});
    experience.addEventListener('load',send);
    window.addEventListener('message',event=>{
      if(event.origin!==origin||event.source!==experience.contentWindow||!pending)return;
      const data=event.data;
      if(data?.type==='olo:marker-navigation-ready'||data?.type==='olo:stand-experience-size'){
        if(!pending.settleUntil||performance.now()<pending.settleUntil)send();
        return;
      }
      if(data?.type==='olo:marker-navigation-cancel'){cancel();return;}
      if(data?.type!=='olo:marker-target'||data.requestId!==pending.id)return;
      const top=Number(data.top),height=Number(data.height);
      if(!Number.isFinite(top)||!Number.isFinite(height)||top<0||height<500||height>20000||top>=height)return;
      if(pending.settleUntil&&performance.now()>pending.settleUntil){cancel();return;}
      if(!pending.settleUntil)pending.settleUntil=performance.now()+2000;
      experience.style.height=Math.ceil(height+8)+'px';
      const header=document.querySelector('[data-eo-header]');
      const inset=header?header.getBoundingClientRect().height+(parseFloat(getComputedStyle(header).top)||0)+16:16;
      const destination=scrollY+experience.getBoundingClientRect().top+top-inset;
      if(Math.abs(scrollY-destination)>2)window.scrollTo({top:Math.max(0,destination),behavior:'instant'});
    });
    begin();
  }
  const frame=document.querySelector('[data-eo-markers]'),note=document.querySelector('[data-eo-loading]');
  if(frame){
    const origin=new URL(frame.src).origin;
    window.addEventListener('message',event=>{
      if(event.origin!==origin||event.source!==frame.contentWindow)return;
      if(event.data?.type==='olo:builder-size'){
        const height=Number(event.data.height);
        if(Number.isFinite(height)&&height>=500&&height<=14000){frame.style.height=Math.ceil(height+8)+'px';frame.scrolling='no';if(note)note.hidden=true;}
      }
    });
    frame.addEventListener('load',()=>{if(note)note.textContent='Your marker workspace is opening. On a slower connection, give the colors a moment to arrive.';});
  }
  document.querySelectorAll('[data-eo-share]').forEach(button=>button.addEventListener('click',async()=>{
    const url=document.querySelector('link[rel=canonical]')?.href||location.href,status=document.querySelector('[data-eo-share-status]');
    try{if(navigator.share)await navigator.share({title:document.title,url});else{await navigator.clipboard.writeText(url);if(status)status.textContent='Link copied.';}}
    catch(error){if(error.name!=='AbortError'&&status)status.textContent='Copy the page address to share.';}
  }));
})();
